export default __webpack_public_path__ + "static/energybox-menu-5d80bda39969320770cc8663c8fdfef9.png";